// @flow
import React from 'react'

const Http404 = (): any => <div className='error-page error-page--404'>
  <div className='error-page__banner'>
    <i className='error-page__banner-image' />
  </div>
  <div className='error-page__body'>
    <i className='error-page__body-image' />
    <div className='error-page__body-text'>
      <h3>404 Not Found</h3>
      <p>You may have put in an incorrect url. Please check the address again.</p>
    </div>
  </div>
</div>

export default Http404
